import { memo } from 'react';
import ContentDialog from '../../uiComponents/ContentDialog/ContentDialog';
import NoResultsDialog from './NoResultsDialog';
import SavedSearchLoader from './SavedSearchLoader';
import SourceSelectionDialog from './SourceSelectionDialog';
import AiSearchForm from './components/AiSearchForm';
import { AiSearchProvider, useAiSearchContext } from './AiSearchContext';
import ConfirmationDialog from '@/components/organisms/ConfirmationDialog';

interface AiSearchComposerProps {
  className?: string;
}

function AiSearchComposerContent({ className = '' }: AiSearchComposerProps) {
  const {
    // Form state
    prompt,
    selectedPromptOption,

    // Dialog states
    isNoResultsDialogOpen,
    isLoaderDialogOpen,
    isSourceSelectionDialogOpen,
    isDeleteConfirmationOpen,

    // Dialog actions
    closeNoResultsDialog,
    closeLoaderDialog,
    closeSourceSelectionDialog,
    closeDeleteConfirmationDialog,

    // Search actions
    handleSelectedSource,

    // Saved search actions
    deleteSavedSearch,

    // Navigation actions
    resetInputForm,
    triggerUploadContent,

    // API data
    loadingRelevantSources,
    relevantSourceList
  } = useAiSearchContext();

  return (
    <>
      <AiSearchForm className={className} />

      {/* Dialogs */}
      <ContentDialog
        isOpen={isNoResultsDialogOpen}
        hideCloseIcon={true}
        size="medium"
        setIsOpen={closeNoResultsDialog}
        disableBackdropClose={true}
      >
        <NoResultsDialog searchTerm={prompt} onClose={resetInputForm} onUpload={triggerUploadContent} />
      </ContentDialog>

      <SavedSearchLoader
        isOpen={isLoaderDialogOpen}
        closeDialog={closeLoaderDialog}
        label={selectedPromptOption?.description || ''}
      />

      <SourceSelectionDialog
        isOpen={isSourceSelectionDialogOpen}
        sourceList={relevantSourceList.contents}
        isLoading={loadingRelevantSources}
        closeDialog={closeSourceSelectionDialog}
        onSourceChanged={handleSelectedSource}
      />

      <ConfirmationDialog
        isOpen={isDeleteConfirmationOpen}
        onClose={closeDeleteConfirmationDialog}
        onConfirm={deleteSavedSearch}
        title="Delete Saved Search?"
        content="Are you sure you want to delete this saved search?"
        confirmLabel="Delete"
      />
    </>
  );
}

function AiSearchComposer({ className = '' }: AiSearchComposerProps) {
  return (
    <AiSearchProvider>
      <AiSearchComposerContent className={className} />
    </AiSearchProvider>
  );
}

export default memo(AiSearchComposer);
